import { createContext, useContext } from "react";

interface TableNavigationContextType {
	visibleTechnicianFields: string[];
	visibleTechnicianGroupFields: string[];
	allNavigableFields: string[];
	totalRows: number;
	processedItems: any[];
}

const TableNavigationContext = createContext<TableNavigationContextType>({
	visibleTechnicianFields: [],
	visibleTechnicianGroupFields: [],
	allNavigableFields: [],
	totalRows: 0,
	processedItems: [],
});

export const TableNavigationProvider = TableNavigationContext.Provider;

export const useTableNavigation = () => {
	return useContext(TableNavigationContext);
};
